/**
 * Every call to the backend lives here, so components never build URLs or
 * repeat fetch options. All calls send the session cookie.
 */

// Relative when served from the same origin (Docker), absolute in dev.
const API_BASE = process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api';

const get = async (path) => {
  const res = await fetch(`${API_BASE}${path}`, { credentials: 'include' });
  return { ok: res.ok, status: res.status, data: await res.json().catch(() => null) };
};

const post = async (path, body) => {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  return { ok: res.ok, status: res.status, data: await res.json().catch(() => null) };
};

export const api = {
  // Auth
  authStatus: () => get('/auth/status'),
  authUrl: () => get('/auth/google'),
  verifySession: () => post('/auth/verify'),
  logout: () => post('/auth/logout'),

  // Stored data
  loadAll: () => get('/data'),
  saveRoster: (roster) => post('/data/roster', roster),
  savePto: (entries) => post('/data/pto', entries),
  saveOverrides: (overrides) => post('/data/overrides', overrides),
  saveClr: (roster, startIndex, anchorDate) => post('/data/clr', { roster, startIndex, anchorDate }),
  saveSettings: (settings) => post('/data/settings', settings),

  // Calendar
  listCalendars: () => get('/calendars'),
  getCalendarClr: (calendarId) =>
    get('/calendar/clr' + (calendarId ? `?calendarId=${encodeURIComponent(calendarId)}` : '')),
  calendarConfig: () => get('/calendar/config'),
  saveCalendarConfig: (config) => post('/calendar/config', config),
  importPto: ({ startDate, endDate, calendarId }) =>
    get(
      `/calendar/pto?startDate=${encodeURIComponent(startDate)}` +
        `&endDate=${encodeURIComponent(endDate)}` +
        `&calendarId=${encodeURIComponent(calendarId)}`
    ),
  syncCalendar: (payload) => post('/calendar/sync', payload),
  syncStatus: () => get('/calendar/sync-status'),
};
